import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Let the browser set the correct multipart/form-data boundary for FormData
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

export const authService = {
  login: (credentials) => api.post('/auth/login', credentials),
  createUser: (userData) => api.post('/auth/users', userData),
  disableUser: (id) => api.patch(`/auth/users/${id}/disable`),
  resetPassword: (id, newPassword) => api.patch(`/auth/users/${id}/reset-password`, { newPassword })
};

export const contentService = {
  // Pass { page, limit } as optional params — e.g. getNews({ page: 2, limit: 10 })
  getNews: (params = {}) => api.get('/news', { params }),
  getNewsById: (id) => api.get(`/news/${id}`),
  createNews: (data) => api.post('/news', data),
  updateNews: (id, data) => api.patch(`/news/${id}`, data),
  deleteNews: (id) => api.delete(`/news/${id}`),

  getEvents: (params = {}) => api.get('/events', { params }),
  getEventById: (id) => api.get(`/events/${id}`),
  createEvent: (data) => api.post('/events', data),
  updateEvent: (id, data) => api.patch(`/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/events/${id}`),

  getAnnouncements: (params = {}) => api.get('/announcements', { params }),
  createAnnouncement: (data) => api.post('/announcements', data),
  updateAnnouncement: (id, data) => api.patch(`/announcements/${id}`, data),
  deleteAnnouncement: (id) => api.delete(`/announcements/${id}`),
};

export const galleryService = {
  getAlbums:    (params = {}) => api.get('/gallery', { params }),
  getAlbum:     (id)         => api.get(`/gallery/${id}`),
  createAlbum:  (data)       => api.post('/gallery', data),
  updateAlbum:  (id, data)   => api.patch(`/gallery/${id}`, data),
  deleteAlbum:  (id)         => api.delete(`/gallery/${id}`),
  uploadPhotos: (albumId, data) => api.post(`/gallery/${albumId}/photos`, data),
  deletePhoto:  (albumId, photoId) => api.delete(`/gallery/${albumId}/photos/${photoId}`),
};

export const dioceseService = {
  getContent:   ()     => api.get('/diocese-content').then(r => r.data),
  updateContent:(data) => api.put('/diocese-content', data).then(r => r.data),
  uploadImage:  (formData) =>
    api.post('/diocese-content/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data),
};

export const rsvpService = {
  register:   (eventId, data)        => api.post(`/events/${eventId}/rsvp`, data),
  listRSVPs:  (eventId, params = {}) => api.get(`/events/${eventId}/rsvps`, { params }),
  removeRSVP: (eventId, rsvpId)      => api.delete(`/events/${eventId}/rsvps/${rsvpId}`),
};

export default api;
